import { createZodDto } from "nestjs-zod/dto";
import z from "zod";

const createReferencePeriodSchema = z.object({
  code: z.string().optional(),
  Start_Date: z.coerce.date(),
  End_Date: z.coerce.date(),
  is_active: z.boolean().optional(),
});

export class CreateReferencePeriodDto extends createZodDto(createReferencePeriodSchema) {}
